<main *mobxAutorun mobxReactionOptions="{fireImmediately: true}">
  <router-outlet></router-outlet>
</main>

<div class="overlay" *ngIf="(loading$ | async) || showLoading">
</div>